import axios from 'axios';

export const dashboardService = {
    getAllDashboardKpisService: (params) => axios.get('/dashboard-kpis', { auth: true, params: { ...params } }),

    getDashboardUserKpisService: (params) => axios.get('/dashboard-kpis/users', { auth: true, params: { ...params } }),

    reorderDashboardKpisService: (body, params) =>
        axios.patch(
            '/dashboard-kpis/users/reorder',
            { kpiIds: body },
            {
                auth: true,
                params: params,
            }
        ),

    deleteDashboardUserKpiService: (id) => axios.delete(`/dashboard-kpis/${id}/users`, { auth: true, params: { id: id } }),

    addDashboardUserKpiService: (id) => axios.post(`/dashboard-kpis/${id}/users`, null, { auth: true }),

    getWidgetsDataService: (url, params) => axios.get(url, { auth: true, params: { ...params } }),
};
